export enum StatusGroupGranularityType {
  Status = 'status',
  StatusGroup = 'statusGroup',
}
